export default [
	{
		code: "ar",
		code_num: "+54",
		flag_1x1: "flags/1x1/ar.svg",
		flag_4x3: "flags/4x3/ar.svg",
		flag_emoji: "🇦🇷",
		iso: true,
		name: "Argentina",
	},
	{
		code: "be",
		code_num: "+32",
		flag_1x1: "flags/1x1/be.svg",
		flag_4x3: "flags/4x3/be.svg",
		flag_emoji: "🇧🇪",
		iso: true,
		name: "Belgium",
	},
	{
		code: "br",
		code_num: "+55",
		flag_1x1: "flags/1x1/br.svg",
		flag_4x3: "flags/4x3/br.svg",
		flag_emoji: "🇧🇷",
		iso: true,
		name: "Brazil",
	},
	{
		code: "ca",
		code_num: "+1",
		flag_1x1: "flags/1x1/ca.svg",
		flag_4x3: "flags/4x3/ca.svg",
		flag_emoji: "🇨🇦",
		iso: true,
		name: "Canada",
	},
	{
		code: "cl",
		code_num: "+56",
		flag_1x1: "flags/1x1/cl.svg",
		flag_4x3: "flags/4x3/cl.svg",
		flag_emoji: "🇨🇱",
		iso: true,
		name: "Chile",
	},
	{
		code: "co",
		code_num: "+57",
		flag_1x1: "flags/1x1/co.svg",
		flag_4x3: "flags/4x3/co.svg",
		flag_emoji: "🇨🇴",
		iso: true,
		name: "Colombia",
	},
	{
		code: "ec",
		code_num: "+593",
		flag_1x1: "flags/1x1/ec.svg",
		flag_4x3: "flags/4x3/ec.svg",
		flag_emoji: "🇪🇨",
		iso: true,
		name: "Ecuador",
	},
	{
		code: "es",
		code_num: "+34",
		flag_1x1: "flags/1x1/es.svg",
		flag_4x3: "flags/4x3/es.svg",
		flag_emoji: "🇪🇸",
		iso: true,
		name: "Spain",
	},
	{
		code: "fr",
		code_num: "+33",
		flag_1x1: "flags/1x1/fr.svg",
		flag_4x3: "flags/4x3/fr.svg",
		flag_emoji: "🇫🇷",
		iso: true,
		name: "France",
	},
	{
		code: "gb",
		code_num: "+44",
		flag_1x1: "flags/1x1/gb.svg",
		flag_4x3: "flags/4x3/gb.svg",
		flag_emoji: "🇬🇧",
		iso: true,
		name: "United Kingdom",
	},
	{
		code: "gy",
		code_num: "+592",
		flag_1x1: "flags/1x1/gy.svg",
		flag_4x3: "flags/4x3/gy.svg",
		flag_emoji: "🇬🇾",
		iso: true,
		name: "Guyana",
	},
	{
		code: "pe",
		code_num: "+51",
		flag_1x1: "flags/1x1/pe.svg",
		flag_4x3: "flags/4x3/pe.svg",
		flag_emoji: "🇵🇪",
		iso: true,
		name: "Peru",
	},
	{
		code: "py",
		code_num: "+595",
		flag_1x1: "flags/1x1/py.svg",
		flag_4x3: "flags/4x3/py.svg",
		flag_emoji: "🇵🇾",
		iso: true,
		name: "Paraguay",
	},
	{
		code: "us",
		code_num: "+1",
		flag_1x1: "flags/1x1/us.svg",
		flag_4x3: "flags/4x3/us.svg",
		flag_emoji: "🇺🇸",
		iso: true,
		name: "United States of America",
	},
	{
		code: "uy",
		code_num: "+598",
		flag_1x1: "flags/1x1/uy.svg",
		flag_4x3: "flags/4x3/uy.svg",
		flag_emoji: "🇺🇾",
		iso: true,
		name: "Uruguay",
	},
	{
		code: "ve",
		code_num: "+58",
		flag_1x1: "flags/1x1/ve.svg",
		flag_4x3: "flags/4x3/ve.svg",
		flag_emoji: "🇻🇪",
		iso: true,
		name: "Venezuela (Bolivarian Republic of)",
	},
];
